import React from 'react';
import { LucideIcon } from 'lucide-react';
import { AnimatedNumber } from './AnimatedNumber';

interface MetricCardProps {
  icon?: LucideIcon;
  label: string;
  value: number;
  formatter: (value: number) => string;
  color: 'orange' | 'maroon' | 'emerald' | 'sky' | 'slate' | 'peach';
  subtext?: string;
  className?: string;
}

const colorClasses = {
  orange: {
    bg: 'bg-[#FAF0EC]',
    icon: 'text-[#6F8D90]',
    value: 'text-[#6F8D90]',
  },
  maroon: {
    bg: 'bg-[#FAF0EC]',
    icon: 'text-[#6F8D90]',
    value: 'text-[#6F8D90]',
  },
  emerald: {
    bg: 'bg-[#FAF0EC]',
    icon: 'text-[#6F8D90]',
    value: 'text-[#6F8D90]',
  },
  sky: {
    bg: 'bg-[#FAF0EC]',
    icon: 'text-[#6F8D90]',
    value: 'text-[#6F8D90]',
  },
  slate: {
    bg: 'bg-[#FAF0EC]',
    icon: 'text-[#6F8D90]',
    value: 'text-[#6F8D90]',
  },
  peach: {
    bg: 'bg-[#FAF0EC]',
    icon: 'text-[#6F8D90]',
    value: 'text-[#6F8D90]',
  },
};

export const MetricCard: React.FC<MetricCardProps> = ({
  icon: Icon,
  label,
  value,
  formatter,
  color,
  subtext,
  className = '',
}) => {
  const colors = colorClasses[color];

  return (
    <div className={`p-4 rounded-xl ${colors.bg} transition-transform duration-200 hover:scale-[1.02] ${className}`}>
      <div className="flex items-start gap-3">
        {Icon && (
          <div className={`p-2 rounded-lg bg-transparent`}>
            <Icon className={`w-5 h-5 ${colors.icon}`} />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-[#A2B7BB] mb-1">{label}</p>
          <p className={`text-2xl font-bold ${colors.value} leading-tight`}>
            <AnimatedNumber value={value} formatter={formatter} />
          </p>
          {subtext && (
            <p className="text-xs text-gray-500 mt-1">{subtext}</p>
          )}
        </div>
      </div>
    </div>
  );
};
